const { initAnalyticsNext } = require('./analyticsNext');

function init(config) {
    initAnalyticsNext(config);
}

module.exports = {
    init: init
};
